import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import RouteNotFoundView from "@/views/site/RouteNotFoundView.vue";
import adminRoutes from "./adminRoutes";
import schoolAdminRoutes from "./schoolAdminRoutes";
import spellingRoutes from "./spellingRoutes";
import mathRoutes from "./mathRoutes";
import testResultRoutes from "./testResultsRoutes";
import storeRoutes from "./storeRoutes";
import userRoutes from "./userRoutes";
import mfRoutes from "./mfRoutes";
import devTestRoutes from "./devTestRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/site/AboutView.vue"),
  },
  {
    path: "/rule-category/:ruleId/:name?",
    name: "HomeRuleCategory",
    component: HomeView,
  },
  {
    path: "/dashboard/:subject?/:year?",
    name: "Dashboard",
    component: () => import("../views/DashboardView.vue"),
  },
  {
    path: "/leaderboard/:subject/:classId?",
    name: "Leaderboard",
    component: () => import("../views/LeaderboardView.vue"),
  },
  {
    path: "/news/maths",
    name: "NewsMaths",
    component: () => import("../views/news/NewsMathsView.vue"),
  },
];

const allRoutes = routes.concat(
  adminRoutes,
  schoolAdminRoutes,
  spellingRoutes,
  mathRoutes,
  testResultRoutes,
  storeRoutes,
  userRoutes,
  mfRoutes,
  devTestRoutes,
);

allRoutes.push({
  path: "/:pathMatch(.*)*",
  component: RouteNotFoundView,
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: allRoutes,
});

export default router;
